import styled from 'styled-components';

export const Wrapper = styled.div`
    background-color: ${({theme}) => theme.colors.verdigrisDark};
    height: 220px;
    padding: ${({theme}) => theme.spacing.m};
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: ${({theme}) => theme.justifyContent.spaceBetween};
`;
export const Controls = styled.div`
    width: ${({theme}) => theme.width.full};
    display: flex;
    align-items: center;
    padding-top: ${({theme}) => theme.spacing.xl};
    justify-content: center;
    gap: ${({theme}) => theme.spacing.m};
`;
export const DisplayName = styled.div`
    color: ${({theme}) => theme.colors.white};
    font-size: ${({theme}) => theme.fontSize.xl};
`;
export const DisplayMetaData = styled.div`
    color: ${({theme}) => theme.colors.white};
`;

export const VolumeContainer = styled.div`
    transform: rotate(-90deg);
    position: absolute;
    right: -60px;
    top: 80px;
    display: flex;
    align-items: center;
`;

export const Track = styled.input`
    -webkit-appearance: none;
    width: ${({theme}) => theme.width.full};
    height: ${({theme}) => theme.spacing.xs};
    background: ${({theme}) => theme.width.white};
    border-radius: ${({theme}) => theme.radius.xs};
    outline: none;
    transition: opacity 0.2s;
    margin: 0 ${({theme}) => theme.spacing.s};

    &::-webkit-slider-runnable-track {
        width: ${({theme}) => theme.width.full};
        height: ${({theme}) => theme.height.h2};
        cursor: pointer;
        background: transparent;
        border-radius: ${({theme}) => theme.radius.xs};
    }

    &::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: ${({theme}) => theme.spacing.m};
        height: ${({theme}) => theme.spacing.m};
        background: ${({theme}) => theme.colors.white};
        cursor: pointer;
        border-radius: 50%;
        border: ${({theme}) => theme.spacing.xxs} solid ${({theme}) => theme.colors.white};
        margin-top: -${({theme}) => theme.spacing.xs};
    }
`;

export const AudioTimeStamp = styled.div`
    display: flex;
    justify-content: ${({theme}) => theme.justifyContent.spaceBetween};
    font-size: ${({theme}) => theme.fontSize.xs};
    color: ${({theme}) => theme.colors.white};
    margin-bottom: 20px;
`;
